export default {
  logistics: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Soluzioni',
    breadcrumbCurrent: 'Magazzino e logistica',
    hero: {
      eyebrow: 'Magazzino e logistica',
      title: 'Sorveglianza di grandi superfici per logistica e magazzini',
      lead: 'Grandangolo, PTZ e visione notturna: copriamo grandi capannoni ed esterni con poche telecamere ben posizionate.',
    },
    areas: {
      title: 'Aree di sorveglianza in magazzino e logistica',
      lead: 'Dall’ingresso al confezionamento: strutturiamo la sorveglianza lungo i flussi di merce, senza lacune.',
      items: {
        '0': { title: 'Ingresso e uscita', desc: 'Ogni veicolo che attraversa il sito viene ripreso, con targa e timestamp per una documentazione completa.' },
        '1': { title: 'Zona di consegna', desc: 'Arrivo e ritiro merci sono momenti delicati. Le telecamere documentano ogni movimento alla rampa.' },
        '2': { title: 'Scaffalature', desc: 'I grandi capannoni richiedono grandi soluzioni. Le telecamere PTZ spaziano sui corridoi e zoomano sul pallet.' },
        '3': { title: 'Picking', desc: 'Confezionamento e picking implicano movimento. Le telecamere di panoramica chiariscono i reclami.' },
        '4': { title: 'Area esterna e cortile', desc: 'Il perimetro è la prima linea di difesa. Telecamere resistenti sorvegliano recinzioni, cancelli e veicoli.' },
        '5': { title: 'Ufficio e amministrazione', desc: 'Anche l’area amministrativa va protetta: valori, documenti e accessi sensibili.' },
      },
    },
    coverage: {
      eyebrow: 'Grandi superfici sotto controllo',
      title: 'Una telecamera, grande effetto',
      lead: 'Nei magazzini conta la visione d’insieme. Invece di tante telecamere singole, usiamo tecnologia che copre grandi aree in modo intelligente.',
      items: {
        '0': { title: 'Telecamere PTZ', desc: 'Pan, tilt, zoom: una telecamera copre grandi aree e fornisce dettagli quando serve.' },
        '1': { title: 'Panoramica grandangolo', desc: 'Per sezioni di capannone ed esterni: telecamere grandangolo compatte catturano grandi aree in una sola immagine.' },
        '2': { title: 'Visione diurna e notturna', desc: 'Infrarossi e sensori molto sensibili danno immagini utili anche al buio, 24 ore su 24.' },
      },
    },
    roundClock: {
      eyebrow: 'Tutto il giorno',
      title: 'Registrazione che non dorme mai',
      lead: 'Il traffico merci non si ferma di notte. Il tuo impianto registra 24 ore su 24 e rende subito reperibili gli eventi rilevanti.',
      list: {
        '0': 'Registrazione 24/7 su registratore locale con periodo definito',
        '1': 'La registrazione su eventi risparmia spazio e facilita la ricerca',
        '2': 'Inoltro allarmi a persone definite al movimento in zone vietate',
        '3': 'Manutenzione regolare di SSG Care per disponibilità duratura',
        '4': 'Ampliabile con altre telecamere e ulteriori sedi',
      },
      note: 'Nota: il periodo di conservazione va adattato ai requisiti operativi ed eventualmente legali. Ti consigliamo al riguardo.',
    },
    cta: {
      title: 'La tua logistica, documentata senza lacune',
      lead: 'Analizziamo flussi di merce e punti di rischio e pianifichiamo un sistema adatto alla tua struttura.',
      primary: 'Fissa un appuntamento di consulenza',
      secondary: 'Scopri SSG Care',
    },
  },
};